import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  allowedTagsExtendedDefault,
  allowedTagsDefault,
  tagsToRemoveDefault,
  allowedAttributesDefault,
  sanitize,
} from '@Services/HtmlSanitizeService';

export default function InnerHTML({
  tag,
  html,
  mode,
  extendedTags,
  allowedTags,
  allowedAttributes,
  tagsToRemove,
  regxsToRemove, // will remove the strings passing this regx from the html
  ...otherProps
}) {
  const CustomTag = `${tag}`;
  const sanitized = useMemo(() => {
    let updatedHtml = html;
    if (extendedTags) {
      // eslint-disable-next-line no-param-reassign, react-hooks/exhaustive-deps
      allowedTags = allowedTagsExtendedDefault;
    }
    if (regxsToRemove && regxsToRemove.length > 0) {
      const combinedRegex = new RegExp(regxsToRemove.map((regex) => regex.source).join('|'), 'g');
      updatedHtml = updatedHtml.replace(combinedRegex, '');
    }
    return sanitize(updatedHtml, mode, { allowedTags, allowedAttributes, tagsToRemove });
  }, [html, mode, extendedTags, allowedTags, allowedAttributes, tagsToRemove]);

  return <CustomTag {...otherProps} dangerouslySetInnerHTML={{ __html: sanitized }} />;
}

InnerHTML.defaultProps = {
  tag: 'span',
  html: '',
  mode: 'discard',
  extendedTags: false,
  allowedTags: allowedTagsDefault,
  allowedAttributes: allowedAttributesDefault,
  tagsToRemove: tagsToRemoveDefault,
  regxsToRemove: [],
};

InnerHTML.propTypes = {
  tag: PropTypes.string,
  html: PropTypes.string,
  mode: PropTypes.string,
  extendedTags: PropTypes.bool,
  allowedTags: PropTypes.array,
  allowedAttributes: PropTypes.array,
  tagsToRemove: PropTypes.array,
  regxsToRemove: PropTypes.array,
};
